module.exports = __webpack_public_path__ + "static/media/cswap-emblem-red.8a918ae0.svg";